<template>
  <div class="column is-4">
    <a href="#" class="video-item-add" @click="add(item)" v-if="!inList">
      <div class="is-relative">
        <img :src="rootPath + item.ch" :alt="item.longtitle" />
        <div class="is-overlay"><span>&plus;</span></div>
      </div>
      <strong>{{ item.pagetitle }}</strong>
    </a>
    <a href="#" class="video-in-list" v-else @click="remove(item)">
      <div class="is-relative">
        <img :src="rootPath + item.ch" :alt="item.longtitle" />
        <div class="is-overlay">
          <span class="add">&check;</span>
          <span class="remove">&Cross;</span>
        </div>
      </div>
      <strong>{{ item.pagetitle }}</strong>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  computed: {
    rootPath() {
      return `${process.env.VUE_APP_ROOT_PATH}`;
    },
    inList() {
      let output = false;
      this.$store.state.currentSeriesVideos.forEach(video => {
        if (parseInt(video.id, 10) === parseInt(this.item.id, 10)) {
          output = true;
        }
      });
      return output;
    }
  },
  methods: {
    add(video) {
      this.$store.dispatch("addVideo", video);
    },
    remove(video) {
      this.$store.dispatch("removeVideo", video);
    }
  }
};
</script>

<style lang="scss">
.video-item-add {
  text-align: center;
  color: rgb(19, 18, 18);
  .is-overlay {
    background-color: rgba(95, 73, 45, 0.6);
    color: white;
    transition: background-color 0.3s ease;
    span {
      font-size: 4rem;
      transition: font-size 0.3s ease;
    }
  }
  &:hover {
    .is-overlay {
      background-color: rgba(72, 199, 116, 0.7);
      span {
        font-size: 4.5rem;
      }
    }
  }
}

.video-in-list {
  text-align: center;
  .is-overlay {
    background-color: rgba(95, 73, 45, 0.6);
    border: 2px solid rgba(72, 199, 116, 1);
    color: white;
    span {
      font-size: 4rem;
      transition: font-size 0.3s ease;
    }
    .add {
      color: rgba(72, 199, 116, 1);
    }
    .remove {
      display: none;
    }
  }
  &:hover {
    .is-overlay {
      background-color: rgba(240, 10, 10, 0.4);
      span {
        font-size: 4.5rem;
      }
      .add {
        display: none;
      }
      .remove {
        display: inline;
      }
    }
  }
}
</style>
